// extracted by mini-css-extract-plugin
module.exports = {"tablet-desktop":"purify_styles__tablet-desktop--DBPMI","tabletDesktop":"purify_styles__tablet-desktop--DBPMI","mobile":"purify_styles__mobile--3nVhk"};